import { Head, CleanContent } from './ui';
import { tiers } from '../data';

export default function StarTiers() {
  return (
    <CleanContent><section className="bg-soft py-5" id="tiers">
        <div className="container">
          <Head eyebrow="The Ten Tiers of Excellence" title="Your Journey From 1 Star to 10 Stars"
            text="Every Star is an institutional milestone in your enterprise lifecycle: clear, unambiguous criteria define each level of national standing" />
          <div className="row g-3 row-cols-2 row-cols-md-3 row-cols-lg-5">
            {tiers.map(([n, s, t, d, u, e]) => (
              <div className="col" key={n}>
                <div className={`bg-white border border-line rounded-3 p-3 h-100 ${n === 10 ? "tier-gold" : ""}`}>
                  <div className="tier-card-header mb-2">
                    <span className="tier-star text-nowrap"><i className="bi bi-star-fill me-1" />{n}</span>
                    <span className="tier-card-score p-sm">{s} Score</span>
                  </div>
                  <div className="h-md mb-1">{t}</div>
                  <p className="p-sm">{d}</p>
                  <div className="p-sm"><i className="bi bi-dot" />{u}</div>
                  <div className="p-sm"><i className="bi bi-dot" />{e}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section></CleanContent>
  );
}
